import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import {
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
} from '@mui/material';
import client from '../../../../../API';

const headerSx = {
  '& th': { bgcolor: 'grey.100', color: 'text.primary', fontWeight: 600 },
};

const FinancialsKPI = ({ delay = 0 }) => {
  const [isReady, setIsReady] = useState(false);

  // Stagger loading with delay
  useEffect(() => {
    const timer = setTimeout(() => setIsReady(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  // Use useQuery for proper caching (replaces useMutation)
  const { data, isLoading, isError, error } = useQuery(
    ['invoices-kpi'],
    client.invoices.listKPI,
    {
      enabled: isReady,  // Only fetch when delay has passed
      staleTime: 10 * 60 * 1000,  // 10 minutes (matches backend cache)
      cacheTime: 15 * 60 * 1000,  // 15 minutes
      refetchOnWindowFocus: false
    }
  );

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error: {error.message}</div>;
  if (!data) return <div>Loading...</div>;

  /* ---- sort by week (string → Date) DESC ---- */
  const sorted = Object.entries(data).sort(
    (a, b) => new Date(b[0]) - new Date(a[0])
  );

  return (
    <Paper elevation={2}>
      <TableContainer>
        <Table stickyHeader>
          <TableHead sx={headerSx}>
            <TableRow>
              <TableCell>Week Starting</TableCell>
              <TableCell>Paid</TableCell>
              <TableCell>Sent</TableCell>
              <TableCell>Pending</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {sorted.map(([week, d]) => (
              <TableRow key={week}>
                <TableCell>{week}</TableCell>
                <TableCell>{d.Paid}</TableCell>
                <TableCell>{d.Sent}</TableCell>
                <TableCell>{d.Pending}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default FinancialsKPI;
